module.exports = __webpack_public_path__ + "img/1440.3f697c3e.jpg";